import { useConnectedAppStatus } from '../../connectedApps/hooks/useConnectedAppStatus'
import { useBootstrap } from './useBootstrap'
import { useTimeEntries } from '../../timeEntries/hooks/useTimeEntries'
import type { WorkspaceActions } from '../components/WorkspaceActionsContext'

type UseAppShellResult = WorkspaceActions & {
  initWorkspace: () => Promise<void>
  handleWebpushObject: (object: any) => Promise<void>
}

export const useAppShell = (): UseAppShellResult => {
  const aliveApps = useConnectedAppStatus()
  const timeEntries = useTimeEntries({
    hasCheckedHeartbeatOnceRef: aliveApps.hasCheckedHeartbeatOnceRef,
    setHasCheckedHeartbeatOnce: aliveApps.setHasCheckedHeartbeatOnce,
    updateAliveApps: aliveApps.updateAliveApps,
  })
  const bootstrap = useBootstrap({
    hasCheckedHeartbeatOnce: aliveApps.hasCheckedHeartbeatOnce,
  })

  return {
    initWorkspace: bootstrap.initWorkspace,
    loadTimeEntries: timeEntries.loadTimeEntries,
    applyTimeEntryPatch: timeEntries.applyTimeEntryPatch,
    handleWebpushObject: timeEntries.handleWebpushObject,
  }
}
